export default "__VITE_ASSET__BT6K7ZBl__"